// Placeholder messages
export const ADD_CATEGORY_MESSAGE = 'Добавьте хотя бы одну категорию';
export const ADD_BRAND_MESSAGE = 'Добавьте хотя бы один бренд';
export const ADD_BRAND_AND_CATEGORY_MESSAGE = 'Добавьте хотя бы одну категорию и один бренд';
export const NO_PRODUCTS_MESSAGE = 'Товаров нет';
export const NO_BRANDS_MESSAGE = 'Нет производителей';
export const NO_CATEGORIES_MESSAGE = 'Нет категорий';
export const NO_FILTERED_RESULTS = 'По заданному фильтру нет товаров';
export const NO_DISCOUNTED_PRODUCTS = 'Нет акционных товаров';
export const NO_PRODUCTS_IN_CART = 'Сложите в корзину нужные товары';
export const NO_ORDERS = 'Нет заказов'

// Alert messages
export const DELETE_CATEGORY_ALERT_MESSAGE = 'Сначала удалите все товары из категории';
export const DELETE_BRAND_ALERT_MESSAGE = 'Сначала удалите все товары бренда';
export const ADDED_TO_WISHLIST = 'Добавлено в избранное';
export const REMOVED_FROM_WISHLIST = 'Удалено из избранного';
export const GO_TO_WISHLIST = 'В избранное';
export const GO_TO_CART = 'В корзину';
export const ADD_TO_WISHLIST = 'В избранное';
export const REMOVE_FROM_WISHLIST = 'В избранном';
export const PRODUCT_ADDED_TO_CART = 'Товар добавлен в корзину';

// Category slice error messages
export const FETCH_CATEGORIES_ERROR_MESSAGE = 'Не удалось загрузить категории. Попробуйте позже';
export const CREATE_CATEGORY_ERROR_MESSAGE = 'Не удалось создать категорию. Попробуйте позже';
export const UPDATE_CATEGORY_ERROR_MESSAGE = 'Не удалось обновить данные. Попробуйте позже';
export const DELETE_CATEGORY_ERROR_MESSAGE = 'Не удалось удалить категорию. Попробуйте позже';

// Brand slice error messages
export const FETCH_BRANDS_ERROR_MESSAGE = 'Не удалось загрузить бренды. Попробуйте позже';
export const CREATE_BRAND_ERROR_MESSAGE = 'Не удалось создать бренд. Попробуйте позже';
export const UPDATE_BRAND_ERROR_MESSAGE = 'Не удалось обновить данные. Попробуйте позже';
export const DELETE_BRAND_ERROR_MESSAGE = 'Не удалось удалить бренд. Попробуйте позже';

// Product slice error messages
export const FETCH_PRODUCTS_ERROR_MESSAGE = 'Не удалось загрузить товары. Попробуйте позже';
export const CREATE_PRODUCT_ERROR_MESSAGE = 'Не удалось создать товар. Попробуйте позже';
export const UPDATE_PRODUCT_ERROR_MESSAGE = 'Не удалось обновить данные. Попробуйте позже';
export const DELETE_PRODUCT_ERROR_MESSAGE = 'Не удалось удалить товар. Попробуйте позже';

// Common slice error messages
export const FETCH_ORDERS_ERROR_MESSAGE = 'Не удалось загрузить заказы. Попробуйте позже';
export const CREATE_ORDER_ERROR_MESSAGE = 'Не удалось оформить заказ. Попробуйте позже';

// Tooltip messages
export const NO_WAY_TO_CHANGE_THIS_PRODUCT =
  'Этот товар нельзя редактировать или удалить. Чтобы попробовать данный функционал добавьте собственный товар';
